import "./Disponibilidad.css";

import {
  FaBuilding,
  FaCheckCircle,
  FaClock,
  FaLock,
} from "react-icons/fa";

import { Link } from "react-router-dom";

const TOTAL_APARTAMENTOS = 13;

const apartamentosDisponibles = [
  {
    id: 1,
    apartamento: "Apartamento 4A",
    tipo: "Tipo A",
    estado: "Disponible",
  },
  {
    id: 2,
    apartamento: "Apartamento 5A",
    tipo: "Tipo A",
    estado: "Disponible",
  },
];

function Disponibilidad() {
  const cantidadDisponibles =
    apartamentosDisponibles.length;

  const cantidadReservados =
    TOTAL_APARTAMENTOS - cantidadDisponibles;

  return (
    <section
      className="disponibilidad"
      id="disponibilidad"
    >
      <div className="disponibilidad-container">

        {/* ENCABEZADO */}

        <div className="disponibilidad-header">
          <div className="disponibilidad-heading">
            <span className="disponibilidad-label">
              DISPONIBILIDAD ACTUAL
            </span>

            <h2>
              Encuentra el apartamento ideal para{" "}
              <strong>tu próximo hogar.</strong>
            </h2>

            <p>
              Consulta las unidades disponibles actualmente
              en Residencial YANNA I y agenda una visita para
              recibir atención personalizada.
            </p>
          </div>

          <div className="disponibilidad-actualizacion">
            <FaClock />

            <div>
              <span>Información actualizada</span>
              <strong>
                Disponibilidad sujeta a confirmación
              </strong>
            </div>
          </div>
        </div>

        {/* RESUMEN */}

        <div className="disponibilidad-resumen">
          <article className="disponibilidad-resumen-card">
            <div className="disponibilidad-resumen-icon">
              <FaBuilding />
            </div>

            <div>
              <span>Total de apartamentos</span>
              <strong>{TOTAL_APARTAMENTOS}</strong>
            </div>
          </article>

          <article className="disponibilidad-resumen-card disponible">
            <div className="disponibilidad-resumen-icon">
              <FaCheckCircle />
            </div>

            <div>
              <span>Disponibles</span>
              <strong>{cantidadDisponibles}</strong>
            </div>
          </article>

          <article className="disponibilidad-resumen-card reservado">
            <div className="disponibilidad-resumen-icon">
              <FaLock />
            </div>

            <div>
              <span>Reservados</span>
              <strong>{cantidadReservados}</strong>
            </div>
          </article>
        </div>

        {/* TABLA */}

        <div className="disponibilidad-tabla-card">
          <div className="disponibilidad-tabla-header">
            <div>
              <span>UNIDADES DISPONIBLES</span>
              <h3>Selecciona tu apartamento</h3>
            </div>

            <div className="disponibilidad-indicador">
              <span></span>
              Disponible
            </div>
          </div>

          <div className="disponibilidad-tabla-scroll">
            <table className="disponibilidad-tabla">
              <thead>
                <tr>
                  <th>Unidad</th>
                  <th>Tipología</th>
                  <th>Estado</th>
                  <th>Acción</th>
                </tr>
              </thead>

              <tbody>
                {apartamentosDisponibles.map(
                  (apartamento) => (
                    <tr key={apartamento.id}>
                      <td>
                        <div className="disponibilidad-unidad">
                          <div>
                            <FaBuilding />
                          </div>

                          <strong>
                            {apartamento.apartamento}
                          </strong>
                        </div>
                      </td>

                      <td>{apartamento.tipo}</td>

                      <td>
                        <span className="disponibilidad-estado">
                          <FaCheckCircle />
                          {apartamento.estado}
                        </span>
                      </td>

                      <td>
                        <Link
                          to="/reserva"
                          className="disponibilidad-boton"
                        >
                          Reservar visita
                        </Link>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>

          <div className="disponibilidad-nota">
            <FaLock />

            <p>
              Los demás apartamentos se encuentran
              reservados. La disponibilidad puede cambiar
              después de la confirmación de una reserva.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Disponibilidad;